import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { OrderedMap } from "immutable";

import { getSpecialFeaturesAsync } from "settings/actions/specialFeatures";
import SettingsWrapper from "settings/components/SettingsWrapper";
import SettingsHeader from "settings/components/SettingsHeader";
import SettingsTable from "settings/components/SettingsTable";
import Search from "settings/components/Search";
import SpecialFeatureRow from "settings/components/SpecialFeatureRow";

class SpecialFeatures extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      filter: "",
    };

    this.handleSearch = this._handleSearch.bind(this);
  }

  componentDidMount() {
    this.props.getSpecialFeaturesAsync();
  }

  _handleSearch(filter) {
    this.setState({ filter });
  }

  render() {
    let specialFeatures = this.props.specialFeatures.toArray();

    if (this.state.filter) {
      specialFeatures = specialFeatures.filter(
        specialFeature =>
          specialFeature.name
            .toLowerCase()
            .indexOf(this.state.filter.toLowerCase()) > -1 ||
          specialFeature.url
            .toLowerCase()
            .indexOf(this.state.filter.toLowerCase()) > -1
      );
    }

    return (
      <SettingsWrapper>
        <SettingsHeader
          title="Special Features"
          description="A special feature is a link to something special on the Axios site. Don’t forget to ensure that the URL works before adding it to the navigation."
        >
          <Search
            placeholder="Find a special feature"
            onChange={this.handleSearch}
          />
        </SettingsHeader>
        <SettingsTable>
          {specialFeatures.map(specialFeature => (
            <SpecialFeatureRow {...specialFeature} key={specialFeature.id} />
          ))}
        </SettingsTable>
      </SettingsWrapper>
    );
  }
}

const mapStateToProps = state => ({
  specialFeatures: state.settings.specialFeatures.specialFeatures,
});

const mapDispatchToProps = {
  getSpecialFeaturesAsync,
};

SpecialFeatures.propTypes = {
  specialFeatures: PropTypes.instanceOf(OrderedMap).isRequired,
  getSpecialFeaturesAsync: PropTypes.func.isRequired,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SpecialFeatures);
